import { BBOX_GENCODES } from '@services/products.service';

import { FaiProduct } from '@app-types/fai';
import { CheckoutFundingType, PaymentMethodType } from '@app-types/order';
import { PRICE_TYPE } from '@app-types/price';
import { Connectivity, FundingEnumType, PlanType } from '@app-types/product';

export const clippBodyHandler = (toogle: boolean): void => {
    if (typeof document !== 'object') return;
    const body = document.querySelector('body');
    if (body === null) return;
    if (toogle) body.classList.add('is-clipped');
    else body.classList.remove('is-clipped');
};

export const scrollToElement = (itemId: string) => {
    try {
        const element = document.querySelector(itemId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
            setTimeout(() => {
                scrollToElement(itemId);
            }, 100);
        }
    } catch (error) {
        //
    }
};

export function spaceAndDotSanitizer(v = '') {
    return v.replace(/\s|\.|_/g, '');
}

export const anonymizeString = (initialString: string, start: number, end: number, replaceWith: string = '-') => {
    const stringStart = initialString.slice(0, start);
    const stringEnd = initialString.slice(end);
    const stringReplacement = replaceWith.repeat(end - start);

    return stringStart + stringReplacement + stringEnd;
};

export function getFundingTypeCash(fundingType: CheckoutFundingType[], isPaypalHidden: boolean) {
    const fy = fundingType.find((mode) => mode.type === FundingEnumType.CASH);
    const isPaymentMethodIban = !!(
        fy &&
        fy.paymentMethods.find((t) => {
            return t.type === PaymentMethodType.FREE;
        })
    );

    const fundingMethods = fy?.paymentMethods.filter((method) => {
        if (isPaypalHidden) {
            return method.type !== PaymentMethodType.PAYPAL;
        }
        return true;
    });

    return {
        fundingTypes: fundingMethods ?? [],
        isPaymentMethodIban,
    };
}

export const maskPhoneInput = (input: HTMLInputElement) => {
    return input.value.replace(/\D/g, '').replace(/(\d{2})(?=\d)/g, '$1 ');
};

export const calculFinalPrice = (
    selectedNetwork: Connectivity | null,
    selectedProduct?: PlanType | null,
    faiProduct?: FaiProduct | null,
): number => {
    if (!selectedProduct) {
        return 0;
    }

    const optionPrice = getOptionPrice(selectedNetwork, selectedProduct);
    const planPrice = getPlanPrice(selectedProduct, faiProduct);

    return optionPrice + planPrice;
};

const getOptionPrice = (selectedNetwork: Connectivity | null, selectedProduct?: PlanType | null): number => {
    if (!selectedProduct) {
        return 0;
    }

    return selectedNetwork === Connectivity.FIVE_G ? selectedProduct?.option5g?.price || 0 : 0;
};

const getPlanPrice = (planSelected: PlanType, faiOfferSelected?: FaiProduct | null) => {
    const { pureFibre: pureFibrePrice, bboxPlusTv: bboxPlusTvPrice } =
        planSelected?.prices.pricesWithBboxIncentive || {};

    if (
        faiOfferSelected?.gencode_offre === BBOX_GENCODES.PURE_FIBRE &&
        pureFibrePrice &&
        planSelected?.prices.final !== pureFibrePrice
    ) {
        return pureFibrePrice;
    }

    if (
        faiOfferSelected?.gencode_offre === BBOX_GENCODES.BBOX_PLUS_TV &&
        bboxPlusTvPrice &&
        planSelected?.prices.final !== bboxPlusTvPrice
    ) {
        return bboxPlusTvPrice;
    }

    return planSelected?.prices.final || 0;
};

export const getPriceType = (priceType: string): PRICE_TYPE => {
    switch (priceType) {
        case 'IMMEDIAT':
            return PRICE_TYPE.TODAY;
        case 'MENSUEL':
            return PRICE_TYPE.MONTHLY;
        case 'DIFFERE':
            return PRICE_TYPE.DEFERRED;
        case 'AUTRE':
            return PRICE_TYPE.OTHER;
        default:
            return PRICE_TYPE.TODAY;
    }
};

export const removeSpacesFromString = (str?: string): string => {
    if (!str) {
        return '';
    }
    return str.replace(/\s/g, '');
};
